import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import style from '../../style/components/overview/MyActivity.module.scss';
import activityIcon from '../../img/icons/activities.svg';

const MyActivity = () => {
  const { t } = useTranslation();

  return (
    <article className={style.activity}>
      <h3 className={style.title}>
        <img src={activityIcon} alt="icon" />
        {t('activity.overview.title')}
      </h3>
      <div className={style.signin}>
        <div className={style.description}>
          {t('activity.overview.description')}
        </div>
      </div>
      <section className={style.manage}>
        <Link to="/signin/privacy">{t('activity.overview.link_viewAll')}</Link>
      </section>
    </article>
  );
};

export default MyActivity;
